import NotificationsList from "components/notification-list/notification-list";

const Notifications: React.FC = () => {
  return (
    <div className="dashboard-container notifications-page">
      <NotificationsList />
    </div>
  );
};

export default Notifications;
